<template>
  <section class="page-container banner">
    <h3 class="sub-heading">Clues Discovered</h3>
    <div v-for="clue in $store.state.currentGame.discoveredClues"
      :key="clue.title" class="clue-card"
      @click="$router.push('/location/follow')">
      <h3 class="clue-card__title">{{clue.location.fields.name}}</h3>
      <div class="clue-card__desc" v-html="clue.details"></div>
      <hr />
    </div>
    <div class="icon-row">
      <icon-buttons back="back" home="/quest/locations" />
    </div>
  </section>
</template>
<style lang="scss">
.clue-card {
  &__title {
    text-transform: uppercase;
    text-align: left;
    font-style: italic;
    font-weight: bold;
    margin-top: 10px;
  }
  &__desc {
    text-align: justify;
  }
}
</style>
<script>
import IconButtons from '@/components/IconButtons.vue';

export default {
  components: {
    IconButtons,
  },
};
</script>
